<template>
  <tea-main @back="goBack"
  >
    <template slot="nav" >
      <div class="stuNav">
        <p @click="goStudent(1)" style="margin-right: 20px">学员查询</p>
        <p @click="goStudent(2)">学员管理（已成功注册）</p>
        <p @click="goPlayer">高水平职业球员认证</p>
        <p class="active" style="background:#4cd964">信息导出</p>
      </div>
    </template>
  
    <template slot="main">
    <div class="person_set-root">
    <div class="main-content-wrap">
      <div class="main-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              :model="formData"
              :rules="settingFormRules"
              ref="mainForm"
              label-width="160px"
              size="medium"
              class="form-cont"
            >
              <el-form-item label="导入方式">
                <el-switch v-model="formData.template_type"
                  active-text="从文件导入"
                  active-value="upload"
                  inactive-text="手动输入"
                  inactive-value="input"></el-switch>
              </el-form-item>
              <el-form-item label="附件上传" v-if="formData.template_type === 'upload'">
                <el-upload
                  ref="uploadFile"
                  action="/api/organization/coach_export_upload.json"
                  :file-list="files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                >
                  <el-button type="primary">点击上传</el-button>
                  <div slot="tip" class>
                    <span>请上传 excel 文件 或&nbsp;</span><a :href="loadExcelUrl"
                    download="" style="color:#4cd964;">下载模板</a>
                    <span>&nbsp;编辑后上传，只能上传xlsx/xls文件，且文件大小不能超过20M</span></div>
                </el-upload>
              </el-form-item>
              <el-form-item label="身份证件号：" prop="idNumbers">
                <el-input type="textarea" v-model="formData.idNumbers" rows="6" placeholder="请输入教练员身份证件号，多个教练员请每行输入一个证件号"></el-input>
              </el-form-item>
              
              <el-form-item label="导出内容：" prop="topTitleList" class="">
                <el-checkbox-group v-model="formData.topTitleList" >
                  <el-checkbox v-for="subject in coachExportTitle" :key="subject.value"
                    :label="subject.value" border>{{subject.key}}
                  </el-checkbox>
                
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
     
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <div class="btn save"
               @click="saveSetting('mainForm')">导出
          </div>
          <div class="btn cancel"
               @click="goBack">返回
          </div>
        </div>
      </div>
    </div>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag"
      :tips="'确定放弃修改并返回吗？'"
      @hideTips="hideTipsDialog"></yioks-tips>
  </div>
    </template>
  </tea-main>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import { coachExportTitle } from "@/assets/js/select";
import {storageData} from "@/assets/js/storage";
import fiveMixins from '@/minix/fiveMixins';
import commonFun from "@/assets/js/yioks";
const { downfile } = commonFun;
import {
  coachExport
} from "@/api/system_manager/api";
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "PersonSet",
  mixins: [fiveMixins],
  
  data() {
    const testFile = {
      type: {
        reg: /^.*\.(xls|xlsx)$/i,
        msg: "请上传Excel文件"
      },
      size: {
        reg: 20,
        msg: "文件不得多于20M"
      }
    };
    const settingFormRules = {
      idNumbers: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
      topTitleList: [{ required: true, message: "请选择导出内容", trigger: "change" }],
    };
    const excelFileUrl = '/uploads/import_tpl/批量录入证件号模板.xlsx'
    return {
      settingFormRules,
      coachExportTitle,
      testFile,
      excelVal: '',
      repeatSubmit: false,
      loadExcelUrl: excelFileUrl,
      vuescrollOpt: createScrollOpt(),
      tipsFlag: false,
      files:[],
      fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
      fileUpParam: {},
      submitDisabled: false,
      formData: {
        template_type: "input",
        idNumbers: "",
        topTitleList: [],
        topTitles:""
      },
      
    };
  },
  computed: {
  
  },
  created() {
  },
  methods: {
    beforeUpload(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        return false;
      }
      if (!/^.*\.(xlsx|xls)$/i.test(file.name)) {
        this.$message.error("请上传  xlsx xls 格式的文件!");
        return false;
      }
      let param = {
        excel: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
    isUping() {
      this.submitDisabled = true;
    },
    uploadError() {
      this.submitDisabled = false;
    },
    uploadSuccess(res) {
      this.submitDisabled = false;
      if (Number(res.status) === 0) {
        this.formData.idNumbers = res.result;
      } else {
        this.$nextTick(() => { });
        this.$message.error(res.msg);
      }
    },
    fileRemove(file, fileList) {
      this.files = fileList;
    },
    saveSetting(formName) {
      this.$refs[formName].validate(valid => {
        const { formData } = this;
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '数据导出中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          coachExport({
            idNumbers: formData.idNumbers.toUpperCase().replace(/\n/ig,','),
            topTitles: formData.topTitleList.join(","),
          })
          .then(({ data }) => {
            if (Number(data.status) === 0) {
              this.$message.success("导出成功");
  
              downfile(data.result.file_url);
              
            } else {
              this.$message.error(data.msg);
            }
            setTimeout(() => {
              loading.close();
            });
          })
          .catch(error => {
            console.info(error);
          });
        } else {
          console.info("error submit!!");
          return false;
        }
      });
    },
    
    goBack() {
      this.$router.push('sm');
    },
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        this.$router.go(-1);
      } else {

      }
    },
    goStudent(idx){
      this.$router.push({
        path: "stu",
        query:{
          idx
        }
      });
    },
    goPlayer(){
      this.$router.push({
        path: "authenticationList",
      });
    },
    openFullScreen2() {
    
    }
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "image-up": () => import("@/components/UpImage/UpImage"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "file-upload": () => import('@/components/UpFile/UpFile'),
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
  }
};
</script>
<style lang="stylus" scoped>
  .stuNav, .stuMain {
    flex: 1 1 auto;
    height: 100%;
  }
  
  .stuNav {
    display: flex;
    align-items: center;
    font-size: 18px;
    p{
      padding: 8px 15px;
      cursor: pointer;
    }
  }
</style>
<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'

$page_main_height = 680px
.person_set-root
  zuxie-page-root()
  .el-form-item {
    margin-bottom: 40px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .no_scroll{
    margin-bottom 0
  }
  .input-w200
    width 200px
  .input-w260
    width 260px
  .input-w273
    width 273px
  .main-content-wrap
    color $color_white
    .nav-wrap
      margin-bottom 20px
      .title
        line-height 1
        font-size $font_size_big
      .nav-right
        color $color_err
        margin-right 12px
    .footer-btn
      text-align center
      .btns {
        display: flex;
        justify-content: center;
        color: $color_white;
        .btn {
          padding: 10px 25px;
          margin: 0 10px;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;
        }
        .save {
          background-color: $color_suc;
        }
        .cancel {
          background-color: $color_err;
        }
      }
    .main-wrap
      display block
      width 100%
      height 560px
      padding 15px 0 0 0
      position relative
      background-color $block_bg_color_base
      margin-bottom 15px
      .form-wrap
        display block
        width 100%
        padding-right 35px
        padding-left 20px
        height 510px
        .form-cont
          select
            outline none
          select[disabled]
            input-disabled()
          .inline-item-wrap
            .form-input-item
              float left
              margin-right 10px
            .form-item-btn
              float left
          .no_scroll
            margin-bottom 0
          .input-right-btn
            margin-right 10px
          .set-sel
            display block
            height 36px
            border 1px solid #dcdfe6
            border-radius 4px
            color #606266
          .up-form-item
            .upfile-wrap
              display block
              .tip
                display block
                font-size $font_size_base
                line-height 30px
        .hide
          display none
        .el-form-item__label
          color $color_white
          font-size 16px
        .el-checkbox__label
          color $color_white
        .el-switch__label
          color $color_white
        .el-switch__label.is-active
          color: #4cd964;
        .el-upload-list__item-name
          color: $color_white;
        .el-checkbox.is-bordered.el-checkbox--medium
          margin-left: 10px;
        .el-input__inner, .el-textarea__inner
          // border-radius 0
        .el-input.is-disabled .el-input__icon
          color #666
        .el-form-item.is-required .el-form-item__label:before
          color inherit
        .el-input.is-disabled .el-input__inner
          input-disabled()
  .edit-phone-dia
    .get_none_code
      position: absolute;
      bottom: -30px;
      cursor: pointer;
      right: 14px;
      color: #606266;
    .btn-fr
      float right
    .input-fl
      float left
    .footer-btn
      padding 10px 0
      // margin-bottom 10px
    .footer-tip
      color $color_err
      font-size $font_size_medium
      text-align center
  .yi-dialog-root
    .btns {
      display: flex;
      justify-content: center;
      color: $color_white;
      .btn {
        padding: 10px 25px;
        margin: 0 10px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
      }
      .save {
        background-color: $color_suc;
      }
      .cancel {
        background-color: $color_err;
      }
    }
</style>

<style lang="stylus">
  .no_code_method
    width 400px
    p
      font-size 14px
      color #606266
      margin-bottom  7px
      &:first-child
        border-bottom 1px solid #606266
        font-size 15px
</style>

